import {
  MSG_RESET, MSG_LIVE_STARTED, MSG_LIVE_SNAPSHOT, MSG_LIVE_ERROR,
  MSG_OLDER_REQUEST, MSG_OLDER_SUCCESS, MSG_OLDER_FAILURE, MSG_SET_HAS_MORE,
  MSG_SENDING, MSG_SENT, MSG_SEND_ERROR, MSG_UPLOAD_PROGRESS, MSG_TOGGLE_PIN, MSG_SET_PINNED_LIST
  ,MSG_PENDING_ADD,MSG_UPLOAD_DONE
} from "./MessagesTypes";

const initial = {
  messagesDesc: [], loading: false, error: null,
  hasMoreOlder: true, loadingOlder: false, oldestCursor: null,
  threadId: null, sending: false, uploadProgress: 0, pinnedList: [], 
};
const dedupe = (a, b) => {
  const map = new Map();
  [...a, ...b].forEach(m => {
    const existing = map.get(m.id) || {};
    map.set(m.id, {
      ...existing,
      ...m,
      pinned: m.pinned !== undefined ? m.pinned : existing.pinned // ✅ keep local pin
    });
  });
  return Array.from(map.values());
};

export const messagesReducer = (state = initial, action) => {
  switch (action.type) {
    case MSG_RESET: return { ...initial };
    case MSG_LIVE_STARTED: return { ...state, loading:true, error:null };
    case MSG_LIVE_SNAPSHOT: {
      const { docsDesc = [], threadId } = action.payload || {};
      const olderOnly = state.messagesDesc.filter(
  x =>
    !docsDesc.find(
      y => y.id === x.id || (x._pending && x.text === y.text && x.senderEmail === y.senderEmail)
    )
);

      const merged = [...docsDesc, ...olderOnly]; // keep DESC
      const oldest = merged[merged.length - 1]?._snapRef || null;
      return { ...state, loading:false, messagesDesc: merged, oldestCursor: oldest, threadId };
    }
    case MSG_LIVE_ERROR: return { ...state, loading:false, error: action.payload };
    case MSG_OLDER_REQUEST: return { ...state, loadingOlder:true, error:null };
    case MSG_OLDER_SUCCESS: {
      const merged = dedupe(state.messagesDesc, action.payload || []);
      const oldest = merged[merged.length - 1]?._snapRef || state.oldestCursor;
      return { ...state, loadingOlder:false, messagesDesc: merged, oldestCursor: oldest };
    }
    case MSG_OLDER_FAILURE: return { ...state, loadingOlder:false, error: action.payload };
    case MSG_SET_HAS_MORE: return { ...state, hasMoreOlder: !!action.payload };
    case MSG_SENDING:
    return {
      ...state,
      messagesDesc: [
        {
          ...action.payload,
          attachments: (action.payload.attachments || []).map(a => ({
            ...a,
            progress: a.progress ?? 0   
          }))
        },
        ...state.messagesDesc,
      ],
    };


    

  
    case MSG_PENDING_ADD: {
      return {
        ...state,
        messagesDesc: [action.payload, ...state.messagesDesc],
      };
    }

    case MSG_UPLOAD_PROGRESS: {
      const { tempId, fileName, pct } = action.payload;
      return {
        ...state,
        messagesDesc: state.messagesDesc.map(m =>
          m.id === tempId
            ? {
                ...m,
                attachments: m.attachments.map(a =>
                  a.name === fileName ? { ...a, progress: pct } : a
                ),
              }
            : m
        ),
      };
    }

    case MSG_UPLOAD_DONE: {
      const { tempId, realMessage } = action.payload;
      return {
        ...state,
        messagesDesc: state.messagesDesc.map(m =>
          m.id === tempId ? { ...realMessage } : m
        ),
      };
    }


    case MSG_SENT: {
      const { tempId, realMessage } = action.payload;
      return {
        ...state,
        messagesDesc: state.messagesDesc.map(m =>
          m.id === tempId ? { ...m, ...realMessage, _pending: false } : m
        ),
      };
    }
    case MSG_SEND_ERROR: {
      const { tempId, error } = action.payload;
      return {
        ...state,
        messagesDesc: state.messagesDesc.map(m =>
          m.id === tempId ? { ...m, _error: error } : m
        ),
      };
    }

    case MSG_TOGGLE_PIN: {
      const { messageId, pinned } = action.payload;

      // Update messagesDesc
      const newMessages = state.messagesDesc.map(m =>
        m.id === messageId ? { ...m, pinned } : m
      );

      // If we already have this message in messagesDesc, use it
      const updatedMsg = newMessages.find(m => m.id === messageId);

      // Update pinnedList optimistically
      let newPinnedList;
      if (pinned) {
        // add if not already there
        const exists = state.pinnedList.some(m => m.id === messageId);
        newPinnedList = exists
          ? state.pinnedList.map(m => m.id === messageId ? { ...m, pinned } : m)
          : [...state.pinnedList, updatedMsg || { id: messageId, pinned }];
      } else {
        // remove from pinnedList
        newPinnedList = state.pinnedList.filter(m => m.id !== messageId);
      }

      return {
        ...state,
        messagesDesc: newMessages,
        pinnedList: newPinnedList
      };
    }




    case MSG_SET_PINNED_LIST: return { ...state, pinnedList: action.payload || [] };

    default: return state;
  }
};
